import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BackofficePaymentReasonMapping  {
    _originalTypeClassName = "zERP.BO.BackofficePaymentReasonMapping";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BackofficePaymentReasonMapping.translate = translateService;
}
this.LineMappings = [];
this.Id = null;
this.BackofficeId = null;
this.BackofficeDescription = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
BackofficeId:any;
BackofficeDescription:any;
LineMappings:any;
InvoiceType:any;
static setLineMappings = ($this, items) => {
                if (items == null) items = [];
                if ($this.LineMappings == null) $this.LineMappings = [];

                const copyItems = Common.cloneObject(items);

                while ($this.LineMappings.length > 0) {
                    Domain.BackofficePaymentReasonMapping.removeLineMappings($this, $this.LineMappings[0]);
                }

                Domain.BackofficePaymentReasonMapping.addManyLineMappings($this, copyItems);
            }
static addManyLineMappings = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BackofficePaymentReasonMapping.addLineMappings($this, items[i]);
                }
            }
static addLineMappings = ($this, item) => {
                if ($this.LineMappings == null) $this.LineMappings = [];
                if (item == null || $this.LineMappings.indexOf(item) > -1) return;
                $this.LineMappings.push(item);
}
static addRangeLineMappings = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BackofficePaymentReasonMapping.addLineMappings($this, item));
            }
static removeLineMappings = ($this, item) => {
                if ($this == null || $this.LineMappings == null || $this.LineMappings.indexOf(item) === -1) return;
                var _index = $this.LineMappings.indexOf(item);
                $this.LineMappings.splice(_index, 1);
}
static clearLineMappings = ($this) => { $this.LineMappings = null; }
static setInvoiceType = ($this, value) => {
var oldValue = $this.InvoiceType;
$this.InvoiceType = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}